export default __webpack_public_path__ + "static/media/vegeterian.6a63a4ef.png";